import React from "react";
import Images from "config/Images";
import {
  DonationDetailsH2,
} from "../DonationDetails/DonationDetails.styles";
import { 
  DonationImage,
  DonationDetailsCol,
  DonationDetailHeader,
  DonationDetailsBody,
  DonationDetailsRow,
  DonationDetailsP,
  DonationDetailsWrapper,
  DonationImageWrapper,
  DonationAmountCents,
  DonationAmountDollars,
  DonationCurrency,
  DonationAmountRow,
  DonationDetailsName,
  ShowMoreTextStyleWrapper,
} from "./MobileDonationDetails.styles";
import ShowMoreText from "react-show-more-text";
import { CampaignInfo } from "types";

interface MobileDonationDetailsProps {
  amountDollars: string,
  amountCents: string,
  campaignInfo: CampaignInfo,
  eventInfo?: EventInfo,
}

function MobileDonationDetails({ eventInfo, campaignInfo, amountDollars, amountCents }: MobileDonationDetailsProps) {
  return(
    <DonationDetailsWrapper>
      <DonationDetailsH2>Donation Details</DonationDetailsH2>

      <DonationDetailsBody>
        <DonationDetailsRow>
          <DonationImageWrapper>
            <DonationImage src={eventInfo ? eventInfo.visuals[0].image_url : campaignInfo.default_image}/>
          </DonationImageWrapper>

          <DonationDetailsCol>
            <DonationDetailHeader>
              {eventInfo?.activity_title}
            </DonationDetailHeader>

            <ShowMoreTextStyleWrapper>
              <ShowMoreText
                lines={1}
                more="View more"
                less="View less"
                className="content-css"
                anchorClass="show-more-less-clickable"
                expanded={false}
                truncatedEndingComponent={"... "}
              >
                <DonationDetailsP>
                  {eventInfo?.activity_description}
                </DonationDetailsP>
              </ShowMoreText>
            </ShowMoreTextStyleWrapper>

            <DonationDetailsRow>
              <DonationDetailHeader>
                Organizer:
              </DonationDetailHeader>

              <DonationDetailsName>
                {eventInfo?.users[0].name}
              </DonationDetailsName>
            </DonationDetailsRow>

            <DonationDetailsRow>
              <DonationDetailHeader>
                Donation amount:
              </DonationDetailHeader>

              <DonationAmountRow>
                <DonationCurrency>$</DonationCurrency>
                <DonationAmountDollars>{amountDollars}</DonationAmountDollars>
                <DonationAmountCents>{`.${amountCents}`}</DonationAmountCents>
              </DonationAmountRow>
            </DonationDetailsRow>
          </DonationDetailsCol>
        </DonationDetailsRow>
      </DonationDetailsBody>
    </DonationDetailsWrapper> 
  );
}

export default MobileDonationDetails;